import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

// Material UI
import { ListItem, List, ListItemIcon, ListItemText, IconButton } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { FormControlLabel } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import { useHistory } from 'react-router-dom';
import { X as XIcon } from 'tabler-icons-react';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const RecursiveListNode = ({
    isChild,
    node,
    drawerOpen,
    openItem,
    selectedItem,
    setDrawerOpen,
    setOpenItem,
    setSelectedItem,
}) => {
    const { children, icon, id, path, text } = node;
    const isSelected = id === selectedItem;
    const isOpen = openItem === id;

    const [value, setValue] = useState('');
    const history = useHistory();
    const IconComponent = icon;
    const [open, setOpen] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [snackMsg, setSnackMsg] = useState('');
    let flag = true;

    const handleOpen = (itemId) => {
        setOpenItem(itemId);
        setSelectedItem(itemId);
        setDrawerOpen(true);
    };

    const handleClose = () => {
        flag = !flag;
        setOpen(false);
    };

    const handleClickList = (itemId) => {
        if (itemId === 'parametros-ritmo') {
            if (flag === true) {
                setOpen(true);
            } else flag = !flag;
        } else {
            if (!isChild) {
                setOpenItem('');
            }
            setSelectedItem(itemId);
            history.push(path);
        }
    };

    const handleSnackClose = () => {
        setOpenSnack(false);
        setOpen(false);
    };

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const tokenSessionObject = JSON.parse(sessionStorage.getItem('token'));

    const getRitmo = useCallback(async () => {
        const data = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/ritmo`, {
            method: 'GET',
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
            },
        });
        if (data !== null) {
            const obj = await data.json();
            setValue(obj.sValor);
        }
    }, [tokenSessionObject.token]);

    const putRitm = () => {
        fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/ritmo?nEstado=${value}`, {
            method: 'PUT',
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
            },
        })
            .then((res) => res.json())
            .catch((error) => console.error('Error: ', error))
            .then((response) => {
                setSnackMsg(response);
                setOpenSnack(true);
            });
    };

    const stdRythm = (event) => {
        event.preventDefault();
        putRitm();
        setOpen(false);
    };

    const body = (
        <div className="ritmo-modal">
            {/* Header */}
            <div className="ritmo-modal-header">
                <h2 className="ritmo-modal-title">Ritmo Base</h2>
                <IconButton size="small" onClick={handleClose}>
                    <XIcon size={18} strokeWidth={2} />
                </IconButton>
            </div>

            {/* Body */}
            <div className="ritmo-modal-body">
                <p className="ritmo-modal-desc">
                    Especifique qué tasa debe usar el sistema para evaluar los cálculos de OEE. El
                    ritmo seleccionado surte efecto al momento de iniciar una corrida de producción.
                </p>
                <RadioGroup value={value} onChange={handleChange}>
                    <FormControlLabel
                        value="ideal"
                        control={<Radio color="primary" />}
                        label={<span className="ritmo-option-label">Ritmo ideal</span>}
                    />
                    <p className="ritmo-option-desc">
                        <strong>Velocidad máxima de la máquina según el fabricante.</strong> Valor
                        comúnmente usado para el cálculo de OEE; suele resultar en valores más bajos
                        por ser un parámetro más exigente.
                    </p>
                    <FormControlLabel
                        value="estandar"
                        control={<Radio color="primary" />}
                        label={<span className="ritmo-option-label">Ritmo estándar</span>}
                    />
                    <p className="ritmo-option-desc">
                        <strong>Velocidad normal de operación de la máquina.</strong> Usado para
                        estimar la duración de corridas en el calendario; suele resultar en valores
                        de OEE más altos.
                    </p>
                </RadioGroup>
            </div>

            {/* Footer */}
            <div className="ritmo-modal-footer">
                <Button className="ritmo-modal-btn" variant="outlined" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button
                    className="ritmo-modal-btn"
                    variant="contained"
                    color="primary"
                    onClick={(e) => stdRythm(e)}
                >
                    Establecer ritmo
                </Button>
            </div>

            <Snackbar open={openSnack} autoHideDuration={3000} onClose={handleSnackClose}>
                <Alert onClose={handleSnackClose} severity="success">
                    {snackMsg}
                </Alert>
            </Snackbar>
        </div>
    );

    useEffect(() => {
        if (id === 'parametros-ritmo') {
            if (value === '') {
                getRitmo();
            }
        }
    }, [getRitmo, id, value]);

    const itemClass = [
        'menu-list-item-root',
        drawerOpen ? 'menu-list-item--open' : '',
        isSelected ? 'menu-list-item--selected' : '',
        isChild ? 'menu-list-item--child' : '',
    ]
        .filter(Boolean)
        .join(' ');

    const iconClass = ['menu-list-icon', isSelected || isOpen ? 'menu-list-icon--active' : '']
        .filter(Boolean)
        .join(' ');

    if (!children) {
        return (
            <ListItem
                button
                onClick={() => handleClickList(id)}
                selected={isSelected}
                classes={{ selected: 'menu-list-item--selected' }}
                className={itemClass}
            >
                <ListItemIcon className={iconClass}>
                    <IconComponent />
                </ListItemIcon>
                <ListItemText primary={text} className="menu-list-text" />
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    {body}
                </Modal>
            </ListItem>
        );
    }

    return (
        <div className={isOpen ? 'menu-item__collapse-wrapper' : undefined}>
            <ListItem
                button
                onClick={() => handleOpen(id)}
                selected={isSelected || isOpen}
                classes={{ selected: 'menu-list-item--selected' }}
                className={itemClass}
            >
                <ListItemIcon className={iconClass}>
                    <IconComponent />
                </ListItemIcon>
                <ListItemText primary={text} className="menu-list-text" />
            </ListItem>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding className="menu-list-nested">
                    {children.map((item) => (
                        <RecursiveListNode
                            node={item}
                            key={item.id}
                            drawerOpen={drawerOpen}
                            selectedItem={selectedItem}
                            setSelectedItem={setSelectedItem}
                            isChild={true}
                        />
                    ))}
                </List>
            </Collapse>
        </div>
    );
};

RecursiveListNode.propTypes = {
    node: PropTypes.shape({
        children: PropTypes.array,
        icon: PropTypes.func,
        id: PropTypes.string,
        path: PropTypes.string,
        text: PropTypes.string,
    }),
    selectedItem: PropTypes.string,
    setSelectedItem: PropTypes.func,
    openItem: PropTypes.string,
    drawerOpen: PropTypes.bool,
    setDrawerOpen: PropTypes.func,
    setOpenItem: PropTypes.func,
    isChild: PropTypes.bool,
};

export default RecursiveListNode;
/*
    This Component intention is to use recursion to render a collection of list item,
    If the node has a children, it will create a <Collapse> item from Material UI
    the data structure of this component is listed in the proptypes.
*/
